<template>
	<div class="layout">
		<div class="header">
			<slot name="header"></slot>
		</div>
		<Navbar></Navbar>

		<Loader :show="loading"></Loader>

		<div class="" v-if="!loading" sticky-container>
			<slot></slot>
		</div>

		<!-- <Footer v-if="!hideFooter" /> -->
	</div>
</template>
<script>
import Navbar from "@/components/Navbar"
import Loader from "@/components/Loader"
// import Footer from '@/components/Footer'

export default {
	name: "Layout",
	props: ["loading", "pageTitle"],
	components: {
		Navbar,
		Loader
		// Footer,
	}
}
</script>

<style scoped lang="scss">
.header {
	// background-image: url("~@/assets/img/home-intro-background.png");
	background-size: cover;
	background-repeat: no-repeat;
	width: 100%;
	top: 0;
	padding: 32px 0 32px 0;
	position: relative;
	left: auto;
	margin-right: 0;
	-webkit-transform: translate(0);
	transform: translate(0);

	h1 {
		color: #fff;
		font-size: 3rem;
		font-weight: 500;
		text-align: center;
		margin-bottom: 0;
	}
}
.main-container {
	padding: 18px;
}
.with-background {
	background-size: contain;
}

@media (max-width: 768px) {
	.with-background {
		background: none !important;
	}
}
@media (max-width: 991px) {
	.main {
		width: 100%;
		margin-left: 0px;
	}
}

.background {
	width: 100%;
	padding-bottom: 280px;
	background-size: cover;
	background-position: center center;
	margin-bottom: -64px;
}
</style>
